import { apiSlice } from '../../app/api/apiSlice';
import { OrderData } from '../../types/order';
import { AddedToCartResponse, CartData, CheckOutResponse,  DefaultResponse, DeleteCartItemResponse, GetGuestInfoResponse, GuestCartResponse, MyOrderResponse, ProductAvailableTimeResponse, UpdateCartQtyResponse } from '../../types/response';
import { GuestInfo } from '../../types/user';
import { AddProductToCartRequest, CheckOutRequest, DeleteCartItemRequest, GuestInfoQueryArgs, UpdateCartProductBody, UpdateCartQtyRequest } from './guestRequestBody';

export const guestApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        addProductToCart: builder.mutation<AddedToCartResponse, AddProductToCartRequest >({
            query: (body) => ({
                url: `/api/cart/add`,
                method: 'POST',
                body,
            }),
            invalidatesTags: [
                { type: 'Cart', id: 'LIST' },
                { type: 'Orders', id: 'LIST' },
            ],
        }),
        getCartByGuestId: builder.query<CartData, number>({
            query: (guestId) => `/api/cart/view/session/${guestId}`,
            transformResponse: (response: GuestCartResponse) => response.data,
            transformErrorResponse: (response) => response.data,
            providesTags: [
                { type: 'Cart', id: 'LIST' },
                { type: 'Orders', id: 'LIST' },
                { type: 'Client', id: 'LIST' },
            ],
        }),
        // removeItem
        removeProductCartById: builder.mutation<DeleteCartItemResponse, DeleteCartItemRequest>({
            query: (data) => ({
                // url: `/api/cart/remove/${clientID}/${productID}/${sessionID}`,
                url: `/api/cart/remove`,
                method: 'DELETE',
                body: data
            }),
            invalidatesTags: (result, error, { clientID } ) => [
                { type: 'Cart', id: 'LIST' },
                { type: 'Cart', id: clientID },
                { type: 'Orders', id: 'LIST' },
                { type: 'Orders', id: clientID },
            ],
        }),
        // updateItem
        updateQtyProductCart: builder.mutation<UpdateCartQtyResponse, UpdateCartQtyRequest>({
            query: (body) => ({
                url: '/api/cart/update',
                method: 'PUT',
                body,
            }),
            invalidatesTags: [{ type: 'Cart', id: 'LIST' }],
        }),
        // checkout // placeOrder
        checkOutOrder: builder.mutation<CheckOutResponse, CheckOutRequest>({
            query: (body) => ({
                url: '/api/cart/checkout',
                method: 'POST',
                body,
            }),
            invalidatesTags: [
                { type: 'Cart', id: 'LIST' },
                { type: 'Orders', id: 'LIST' },
                { type: 'Client', id: 'LIST' },
            ],
        }),
        getMyOrderByGuestId: builder.query<OrderData[], number>({
            query: (guestId) => `/api/orders/session/${guestId}`,
            transformResponse: (response: MyOrderResponse) => response.data,
            transformErrorResponse: (response) => response.data,
            providesTags: (result, error, guestId ) => [
                { type: 'Orders', id: guestId },
                { type: 'Orders', id: 'LIST' },
                { type: 'Cart', id: 'LIST' },
                { type: 'Cart', id: guestId },
            ],
        }),
        // cancelOrderBySession
        cancelledMyOrder: builder.mutation<DefaultResponse, number>({
            query: (orderId) => ({
                url: `/api/orders/cancel/session/${orderId}`,
                method: 'PUT',
            }),
            invalidatesTags: (result, error, orderId ) => [
                { type: 'Orders', id: 'LIST' },
                { type: 'Orders', id: orderId },
                { type: 'Cart', id: 'LIST' },
                { type: 'Cart', id: orderId },
            ],
        }),
        getAllProductAvailableTime: builder.query<ProductAvailableTimeResponse, number>({
            query: (clientId) => `/api/clients/${clientId}/product/date`,
            transformResponse: (response: ProductAvailableTimeResponse) => response,
            transformErrorResponse: (response) => response,
            providesTags: (result, error, clientId ) => [
                { type: 'Client', id: clientId },
                { type: 'Client', id: 'LIST' },
                { type: 'Cart', id: 'LIST' },
            ],
        }),
        getGuestInfoBaseOnChapelAndClient: builder.query<GuestInfo[], GuestInfoQueryArgs>({
            query: ({ chapelID, clientID, orderBy }) => `/api/sessions/${chapelID}/${clientID}?orderBy=${orderBy}`,
            transformResponse: (response: GetGuestInfoResponse) => response.data,
            transformErrorResponse: (response: any) => response.data,
            providesTags: [
                { type: 'Client', id: 'LIST' },
                { type: 'Orders', id: 'LIST' },
                { type: 'Cart', id: 'LIST' },
                { type: 'Orders', id: 'LIST' },
            ],
        }),
        updateProductCart: builder.mutation<DefaultResponse, UpdateCartProductBody>({
            query: (body) => ({
                url: "/api/cart/update",
                method: "PUT",
                body,
            }),
            invalidatesTags: (result, error, body) => [
                { type: "Orders", id: "LIST" },
                { type: "Cart", id: "LIST" },
                { type: "Client", id: "LIST" },
            ],
        }),
    }),
    overrideExisting: false, 
});

export const {
    useAddProductToCartMutation,
    useGetCartByGuestIdQuery, // get
    useLazyGetCartByGuestIdQuery, // lazy
    useRemoveProductCartByIdMutation,
    useUpdateQtyProductCartMutation,
    useCheckOutOrderMutation,
    useGetMyOrderByGuestIdQuery, // get
    useCancelledMyOrderMutation,
    useGetAllProductAvailableTimeQuery,
    useGetGuestInfoBaseOnChapelAndClientQuery,
    useUpdateProductCartMutation,
} = guestApiSlice;